import React from 'react';
import { Link } from 'react-router-dom';
import { imagePath } from '../../utils/imagePath';

/**
 * StaticBanners - Static banner section with 3 banners
 * Follows React Rules: Pure component
 */
const StaticBanners = () => {
  const banners = [
    { image: 'banner/1_3.jpg', link: '/store/shop', alt: 'Banner 1' },
    { image: 'banner/1_4.jpg', link: '/store/shop', alt: 'Banner 2' },
    { image: 'banner/1_5.jpg', link: '/store/shop', alt: 'Banner 3' }
  ];

  return (
    <div className="li-static-banner">
      <div className="container">
        <div className="row">
          {banners.map((banner, index) => (
            <div
              key={index}
              className={`col-lg-4 col-md-4 text-center ${index > 0 ? 'pt-xs-30' : ''}`}
            >
              <div className="single-banner">
                <Link to={banner.link}>
                  <img src={imagePath(banner.image)} alt={banner.alt} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StaticBanners;

